import styled from "@emotion/styled";
import { Box, Button, colors, Typography, useTheme } from "@mui/material";
import { Stack } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { blueTick, dummyNft6 } from "../../../assets";
import { BORROWED, nftTempImage, ON_LEND, ON_RENT } from "../../../constants";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { tokens } from "../../../theme";
import BasicSelect from "./Select";
import { SplineChart } from "./SplineChart";

const StyledButton = styled(Button)(({ theme, colors, width }) => ({
  backgroundColor: colors.whiteAccent[900],
  color: colors.primary[500],
  fontSize: "14px",
  fontWeight: 400,
  width: width || "48%",
  height: "40px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

const NftDetails = ({ setStep }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // const nft = {
  //   name: "Axie",
  //   tokenId: "#969",
  //   contractName: "Axie Infinity",
  //   nftAddress: "mrFYLJRhgULb7ZL7SyKhdGnKHvTxXxkXPG",
  // };

  const [nft, setNft] = useState({});

  const { address, tokenId } = useParams();

  console.log("params", address, tokenId);

  const { profileNfts } = useTypedSelector((state) => state.apiReducer);
  const { role } = useTypedSelector(
    (state) => state.apiReducer.connectedAccount
  );

  console.log("{ profileNfts }", {
    profileNfts,
  });

  useEffect(() => {
    setNft(
      profileNfts.find(
        (nft) => nft.tokenId === tokenId && nft.nftAddress === address
      )
    );
  }, []);

  useEffect(() => {
    setNft(
      profileNfts.find(
        (nft) => nft.tokenId === tokenId && nft.nftAddress === address
      )
    );
  }, [profileNfts]);

  console.log("nft from param", nft);
  return (
    <>
      <Typography variant="" color={colors.black[500]} fontWeight={500}>
        NFT Details
      </Typography>

      <Stack
        direction="row"
        alignItems={"flex-start"}
        justifyContent="space-between"
        width="100%"
        sx={{ marginTop: "20px", marginBottom: "70px" }}
      >
        {/* <Box> */}
        <img
          src={nft?.image}
          alt="nft"
          onError={(e) => (e.currentTarget.src = nftTempImage)}
          style={{
            width: "424px",
            height: "418px",
            borderRadius: "7px",
          }}
        />
        {/* </Box> */}
        <Box
          sx={{
            height: "350px",
            width: "70%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            marginTop: "40px",
            marginLeft: "20px",
          }}
        >
          <Box>
            <Typography
              variant="h2"
              fontWeight={500}
              color={colors.black[900]}
            >{`${nft?.name || ""} #${tokenId}`}</Typography>
            <Stack direction="row" mt="10px" mb="10px">
              <img src={blueTick} alt="ble tick" />
              <Typography
                variant="body1"
                fontWeight={400}
                color={colors.blueAccent[400]}
                sx={{ textDecoration: "underline" }}
              >
                {nft?.contractName}
              </Typography>
            </Stack>
            <Typography
              variant="body2"
              fontWeight={400}
              color={colors.black[900]}
              sx={{ textDecoration: "underline" }}
            >
              {address}
            </Typography>
          </Box>
          {/* <Stack
            direction="row"
            alignItems={"center"}
            justifyContent="space-between"
            sx={{ height: "80px", borderBottom: "1px solid #E8ECF5" }}
          >
            <Typography
              variant="caption"
              fontWeight={500}
              color={colors.black[500]}
            >
              Rental Floor Price
            </Typography>
            <Typography variant="h5" fontWeight={500} color={colors.black[500]}>
              {"$1052.00"}
            </Typography>
          </Stack>

          <Stack
            direction="row"
            alignItems={"center"}
            justifyContent="space-between"
          >
            <Typography
              variant="caption"
              fontWeight={500}
              color={colors.black[500]}
              sx={{ height: "80px", borderBottom: "1px solid #E8ECF5" }}
            >
              Sale Floor Price
            </Typography>
            <Typography variant="h5" fontWeight={500} color={colors.black[500]}>
              {"$1052.00"}
            </Typography>
          </Stack> */}
          <BasicSelect properties={nft?.properties || []} />
        </Box>
      </Stack>

      {/* <Box width="100%" marginBottom="100px">
        <SplineChart />
      </Box> */}

      {role === "GUILD" ? (
        <Box
          display="flex"
          flexDirection="row"
          width="98%"
          // marginTop="20px"
          marginBottom="5px"
          alignItems={"center"}
          justifyContent={"space-between"}
          pl={1}
          sx={{ position: "absolute", bottom: 0 }}
        >
          <StyledButton
            onClick={() => setStep(1)}
            variant="outlined"
            colors={colors}
            disabled={nft?.status === ON_LEND || nft?.status === ON_RENT}
          >
            Yield Split
          </StyledButton>

          <StyledButton
            onClick={() => setStep(2)}
            variant="outlined"
            colors={colors}
            disabled={nft?.status === ON_LEND || nft?.status === ON_RENT}
          >
            Send
          </StyledButton>
        </Box>
      ) : (
        <Box
          display="flex"
          flexDirection="row"
          width="98%"
          marginTop="20px"
          marginBottom="5px"
          alignItems={"center"}
          justifyContent={"space-between"}
          pl={1}
          sx={{ position: "absolute", bottom: 0 }}
        >
          <StyledButton
            onClick={() => setStep(2)}
            variant="outlined"
            colors={colors}
            width="100%"
            disabled={nft?.status === ON_LEND || nft?.status === ON_RENT}
          >
            Send
          </StyledButton>
        </Box>
      )}
    </>
  );
};

export default NftDetails;
